import { getAuth } from 'firebase/auth'
import React, { FunctionComponent, useEffect, useRef, useState } from 'react'

import { useDispatch } from 'react-redux'
import Alert, { AlertType } from '../../components/atoms/Alert/Alert'
import WhitelistCard from '../../components/molecules/WhitelistCard'
import useConnectRequest from '../../hooks/useConnectRequest'
import { GET_WHITELIST } from '../../redux/requests/auth/auth.actions'
import requestActions from '../../redux/requests/requestActions'

import * as S from './styled'
type OwnProps = {}

type Props = OwnProps

export const Whitelist: FunctionComponent<Props> = () => {
  const dispatch = useDispatch()
  const auth = getAuth()
  const user = auth.currentUser
  const email = useRef<HTMLInputElement>(null)
  const [isInvalidEmail, setIsInvalidEmail] = useState(false)
  const { data: whitelist, loading: loadingWhitelist } = useConnectRequest(GET_WHITELIST)
  const [wlState, setWlState] = useState(whitelist)
  const [radioValue, setRadioValue] = useState('email')
  useEffect(() => {
    if (user) {
      dispatch(requestActions.auth.getWhitelist(user.uid))
    }
  }, [])
  useEffect(() => {
    if (whitelist) {
      setWlState(whitelist)
    }
  }, [whitelist])

  function handleClick() {
    const emailRegex =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
    const domainRegex = /^@[a-zA-Z0-9]+.([a-zA-Z0-9]{2,3}$|[a-zA-Z0-9]{2,3}.[a-zA-Z0-9]{2,3}$)/

    const regex = radioValue === 'email' ? emailRegex : domainRegex

    if (!regex.test(email.current!.value)) {
      setIsInvalidEmail(true)
      return
    }

    if (user) {
      dispatch(requestActions.products.addWhitelistItem(user.uid, email.current!.value, dispatch))
      email.current!.value = ''
      email.current!.blur()
    }
  }

  function handleChange(e) {
    email.current!.value = e.target.value
    setIsInvalidEmail(false)
  }

  return (
    <S.Container>
      {isInvalidEmail && (
        <Alert type={AlertType.Error} message={'ange en epost-adress med giltigt format'} />
      )}
      <S.BackgroundDiv>
        <S.RadioStyled>
          <div>
            <input
              id="domain"
              type="radio"
              value="domain"
              name="whitelist"
              onClick={() => {
                setRadioValue('domain')
              }}
            />
            <label htmlFor="domain">Lägg till domän</label>
          </div>
          <div>
            <input
              id="email"
              type="radio"
              value="email"
              name="whitelist"
              defaultChecked
              onClick={() => {
                setRadioValue('email')
              }}
            />
            <label htmlFor="email">Lägg till mail adress</label>
          </div>
        </S.RadioStyled>

        <S.AddWhitelistContainer>
          {radioValue === 'email' && (
            <input
              ref={email}
              type={'email'}
              placeholder={'email@mail.se'}
              onChange={handleChange}
              onKeyUp={e => (e.key === 'Enter' ? handleClick() : '')}
            />
          )}
          {radioValue === 'domain' && (
            <input
              ref={email}
              type={'email'}
              placeholder={'@domän.se'}
              onChange={handleChange}
              onKeyUp={e => (e.key === 'Enter' ? handleClick() : '')}
            />
          )}
          <button onClick={handleClick}>+</button>
        </S.AddWhitelistContainer>
      </S.BackgroundDiv>
      <S.L1>Vitlistade epost-adresser</S.L1>
      <S.WhitelistContainer>
        {whitelist &&
          !loadingWhitelist &&
          wlState.map(item => {
            return <WhitelistCard setWlState={setWlState} key={item} email={item}></WhitelistCard>
          })}
      </S.WhitelistContainer>
    </S.Container>
  )
}

export default Whitelist
